// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileAudioIconSignature {
  Element: SVGSVGElement;
}

export const FileAudioIcon: TOC<FileAudioIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 1.00299H16.414L21 5.58899V21.003C21 22.106 20.103 23.003 19 23.003H5C3.897 23.003 3 22.106 3 21.003V3.00299C3 1.89999 3.897 1.00299 5 1.00299ZM5 3.00299V21.003H19.001L19 7.00299H15V3.00299H5ZM7 13.005V17.005H10L13 19.005V11.005L10 13.005H7ZM15 15.005C15 14.613 14.576 14 14.29 13.709L15.707 12.298C15.839 12.431 17 13.631 17 15.005C17 16.379 15.839 17.58 15.707 17.712L14.293 16.298C14.576 16.01 15 15.397 15 15.005Z"/>
</svg>
</template>;